export const FETCH_STREETS = 'fetchStreets';
export const SET_STREETS = 'setStreets';
export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const AUTH_REQUEST = 'authRequest';
export const AUTH_SUCCESS = 'authSuccess';
export const AUTH_ERROR = 'authError';
export const CHECK_AUTH = 'checkAuth';
export const RELOAD_USER = 'reloadUser';
export const FETCH_DOCUMENTS = 'fetchDocuments';
export const GET_DOCUMENT = 'getDocument';
